import { useMemo } from "react";

import { useNode } from "@craftjs/core";
import { get } from "lodash";

export function useCraftOptions() {
  const { actions: { setCustom: setValue }, value } = useNode(({ data: { custom } }) => ({
    value: get(custom, 'options'),
  }))

  const options = useMemo(() => !value ? [] : Object.entries(value)
    .map(([key, { name, label, value, ...data }]) => ({
      value: value || key,
      label: label || name,
      ...data,
    })), [value])

  return {
    value, setValue,
    options,
  }
}
